import React, { useState } from 'react'
import { Breadcrumb, Modal } from 'react-bootstrap';
import DashboardLayout from '../../components/layouts/dashboardLayout';
import TawkTo from '../../components/forms/plugins/TawkTo';
import LiveChatINC from "../../components/forms/plugins/liveChatINC"
import { useSelector } from 'react-redux';
import GoogleAnalytics from '../../components/forms/plugins/GoogleAnalytics';
import GoogleSearch from '../../components/forms/plugins/GoogleSearch';
import TiktokPixel from '../../components/forms/plugins/TiktokPixel';
import MetaPixel from '../../components/forms/plugins/MetaPixel';


function Plugins() {
   let plugins = useSelector(data => data?.profile?.data?.setting?.plugins);
   const [pluginModel, setPluginModel] = useState(false);
   const [pluginTitle, setPluginTitle] = useState("");
   const [pluginKey, setPluginKey] = useState("");
   const [data, setData] = useState({})

   let pluginsList = [
      {
         pluginImage: "/assets/images/plugins/Tawk.to.png",
         title: "Tawk.to",
         pluginKey: "",
         description: "Free Live Chat Software to monitor and chat with visitors on your website or from a free customizable page.",
         status: plugins?.tawkTo?.status,
         implementationStatus: plugins?.tawkTo !== "",
         pluginKey: "tawkTo",
         data: plugins?.tawkTo
      },
      {
         pluginImage: "/assets/images/plugins/livechat.png",
         title: "Live Chat",
         pluginKey: "liveChatINC",
         description: "Engage with your website visitors in real-time using our free Live Chat Software, customizable to fit your needs.",
         status: plugins?.liveChatINC?.status,
         implementationStatus: plugins?.liveChatINC !== "",
         data: plugins?.liveChatINC
      },
      {
         pluginImage: "/assets/images/plugins/Google Analytics.png",
         pluginKey: "",
         title: "Google Analytics",
         description: "Get a complete understanding of your customers across devices and platforms. Google Analytics gives you the tools, free of charge, to understand the customer.",
         status: plugins?.googleAnalytics?.status,
         pluginKey: "googleAnalytics",
         implementationStatus: plugins?.googleAnalytics !== "",
         data: plugins?.googleAnalytics
      },
      {
         pluginImage: "/assets/images/plugins/Google Search Console.png",
         title: "Google Search",
         pluginKey: "",
         description: "Search Console tools and reports help you measure your site's Search traffic and performance, fix issues and make your site shine in Google Search results",
         status: plugins?.googleSearch?.status,
         pluginKey: "googleSearch",
         implementationStatus: plugins?.googleSearch !== "",
         data: plugins?.googleSearch
      },
      {
         pluginImage: "/assets/images/plugins/Meta Pixel.webp",
         title: "Meta Pixel",
         pluginKey: "",
         description: "Measure, optimize & retarget audiences for your ad campaigns on Facebook & Instagram",
         status: plugins?.metaPixel?.status,
         pluginKey: "metaPixel",
         implementationStatus: plugins?.metaPixel !== "",
         data: plugins?.metaPixel
      },

      {
         pluginImage: "/assets/images/plugins/Tiktok Pixel.jpg",
         title: "Tiktok Pixel",
         description: "The TikTok Pixel is a piece of code that you can place on your website that allows you to share website visitor events to TikTok via a browser.",
         status: plugins?.tiktokPixel?.status,
         pluginKey: "tiktokPixel",
         implementationStatus: plugins?.tiktokPixel !== "",
         data: plugins?.tiktokPixel
      },
      {
         pluginImage: "/assets/images/plugins/shopify.png",
         title: "Shopify",
         description: "E-commerce platform to build your online store and sell products.",
         status: false,
         pluginKey: "",
      },
      {
         pluginImage: "/assets/images/plugins/Mailchimp.png",
         title: "Mailchimp",
         pluginKey: "",
         description: "Marketing automation platform and an email marketing service.",
         status: false,
      },
      {
         pluginImage: "/assets/images/plugins/HubSpot.png",
         title: "HubSpot",
         description: "Inbound marketing, sales, and service software that helps companies attract visitors, convert leads, and close customers.",
         pluginKey: "",
         status: false,
      },
      {
         pluginImage: "/assets/images/plugins/Salesforce.png",
         title: "Salesforce",
         description: "Customer relationship management solution that brings companies and customers together.",
         status: false,
         pluginKey: "",
      },
      {
         pluginImage: "/assets/images/plugins/Zendesk.png",
         title: "Zendesk",
         pluginKey: "",
         description: "Customer service software and support ticketing system.",
         status: false,
      },
      {
         pluginImage: "/assets/images/plugins/Slack.png",
         pluginKey: "",
         title: "Slack",
         description: "Collaboration hub that connects your work with the people you work with.",
         status: false,
      },
      {
         pluginImage: "/assets/images/plugins/Zoom.avif",
         pluginKey: "",
         title: "Zoom",
         description: "Video conferencing software that offers video, voice, and screen-sharing capabilities.",
         status: false,
      },
      {
         pluginImage: "/assets/images/plugins/Dropbox.png",
         pluginKey: "",
         title: "Dropbox",
         description: "File hosting service that offers cloud storage, file synchronization, personal cloud, and client software.",
         status: false,
      },
      {
         pluginKey: "",
         pluginImage: "/assets/images/plugins/Trello-logo.png",
         title: "Trello",
         description: "Web-based, Kanban-style, list-making application.",
         status: false,
      },
      {
         pluginImage: "/assets/images/plugins/Asana.png",
         title: "Asana",
         pluginKey: "",
         description: "Web and mobile application designed to help teams organize, track, and manage their work.",
         status: false,
      },
      {
         pluginImage: "/assets/images/plugins/Microsoft Teams.png",
         title: "Microsoft Teams",
         pluginKey: "",
         description: "Collaboration app that helps your team stay organized and have conversations all in one place.",
         status: false,
      },
      {
         pluginImage: "/assets/images/plugins/wordpress.webp",
         pluginKey: "",
         title: "WordPress",
         description: "Open-source content management system used to build websites and blogs.",
         status: false,
      }
   ];

   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>plugins</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className="bg-white p-3 overflow-hidden">
                        <div className="d-flex justify-content-between border-bottom  pb-2">
                           <div>
                              <h4>Plugins</h4>
                           </div>
                        </div>
                        <br />
                        <div className="row">
                           <div className="col-12">
                              <p className="text-muted" style={{ fontSize: "1rem" }}>
                                 Our team is currently working on these plugins. Once they are ready, we will make them live for all users. Stay tuned for updates!
                              </p>
                           </div>
                        </div>
                        <div className="row">
                           {pluginsList?.map((data, index) => {
                              return (
                                 <div key={index} className="col-12 mb-1">
                                    <div className="plugin-card p-2 border rounded d-flex">
                                       <img src={data.pluginImage} alt={data.title} className="img-fluid" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "8px" }} />
                                       <div className="ms-4 w-100">
                                          <h5 className="plugin-title mb-2">{data.title}</h5>
                                          <p className="plugin-description mb-2">{data.description}</p>
                                          <span className={`badge ${data.status ? 'bg-success' : 'bg-secondary'}`}>
                                             {data.status ? 'Active' : 'Inactive'}
                                          </span>
                                          <div className='d-flex justify-content-end'>
                                             <div>
                                                {data?.implementationStatus ? (
                                                   <button className='btn rounded-0 btn-dark'
                                                      onClick={() => {
                                                         setPluginModel(true);
                                                         setPluginTitle(data?.title);
                                                         setPluginKey(data?.pluginKey);
                                                         setData(data?.data);
                                                      }}
                                                   >
                                                      {data?.status ? "View" : "Activate"}
                                                   </button>
                                                ) : (
                                                   <p className="text-muted text-end mt-1" style={{ fontSize: "1rem", fontWeight: "bold", color: "#ff5733" }}>Coming Soon</p>
                                                )}
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              )
                           })}
                        </div>
                     </div>
                     <br />
                  </div>
               </div>
            </div>
         </DashboardLayout>
         <Modal size="lg" show={pluginModel} onHide={() => setPluginModel(false)}>
            <Modal.Header closeButton>
               <Modal.Title>{pluginTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               {pluginKey == "tawkTo" && <TawkTo data={data} setPluginModel={setPluginModel} />}
               {pluginKey == "liveChatINC" && <LiveChatINC data={data} setPluginModel={setPluginModel} />}
               {pluginKey == "googleAnalytics" && <GoogleAnalytics data={data} setPluginModel={setPluginModel} />}
               {pluginKey == "googleSearch" && <GoogleSearch data={data} setPluginModel={setPluginModel} />}
               {pluginKey == "tiktokPixel" && <TiktokPixel data={data} setPluginModel={setPluginModel} />}
               {pluginKey == "metaPixel" && <MetaPixel data={data} setPluginModel={setPluginModel} />}
            </Modal.Body>
         </Modal>
      </>
   )
}

export default Plugins